export const partnerCustomersMessages = {
  en: {
    partnerCustomers: {
      // ── Nav ───────────────────────────────────────────────────────────────
      navTitle:    'Customers',
      navOverview: 'Overview',

      // ── Overview ─────────────────────────────────────────────────────────
      overviewTitle:       'Managed Detection Service',
      overviewDescription: 'Monitor your customers\' cyber risk exposure. Confirmed hack post matches drive the risk score; sector and country activity provides contextual risk when no direct matches exist.',
      kpiTotal:            'Total Customers',
      kpiActive:           'Active',
      kpiWithWorkflows:    'With Workflows',
      kpiConfirmedMatches: 'Confirmed Matches',
      kpiPendingMatches2:  'Pending Review',
      top10Title:          'Top 10 At-Risk Customers',
      top10Empty:          'No risk data yet. Run the matching workflow or wait for the next cycle.',
      colRank:             '#',
      colConfirmedMatches: 'Confirmed',
      colPendingMatches:   'Pending',
      toListBtn:           'All Customers →',

      // ── List view ─────────────────────────────────────────────────────────
      pageTitle:   'Customers',
      addBtn:      'New Customer',
      searchPlaceholder: 'Search by name…',
      colName:         'Name',
      colIndustry:     'Industry',
      colCountry:      'Country',
      colSize:         'Size',
      colWorkflows:    'Workflows',
      colRisk:         'Risk',
      colActive:       'Active',
      colActions:      'Actions',
      editTooltip:     'Edit',
      deleteTooltip:   'Delete',
      emptyState:      'No customers yet. Add your first customer to get started.',
      loadFailed:      'Customers could not be loaded.',
      filterRisk:      'Risk',
      filterIndustry:  'Industry',
      filterAll:       'All',
      filterActive:    'Active only',
      deleteFailed:    'Delete failed.',
      deleteConfirm:   'Delete customer "{name}" and all associated data? This cannot be undone.',

      // ── Create / Edit dialog ──────────────────────────────────────────────
      dialogCreate:       'New Customer',
      dialogEdit:         'Edit Customer',
      fieldName:          'Name',
      fieldNamePlaceholder:'Company name',
      fieldCountry:       'Country (ISO-2)',
      fieldCountryPlaceholder: 'e.g. DE',
      fieldIndustry:      'Industry',
      fieldIndustryPlaceholder: 'Select industry',
      fieldSize:          'Company Size',
      fieldSizePlaceholder:    'Select range',
      fieldExternalId:    'External ID',
      fieldExternalIdPlaceholder: 'e.g. client ID',
      fieldDomains:       'Domains',
      fieldDomainsPlaceholder: 'e.g. acme.de',
      fieldDomainsHint:   'Press Enter to add a domain',
      fieldAliases:       'Aliases',
      fieldAliasesPlaceholder: 'Alternative company names',
      fieldAliasesHint:   'Press Enter to add an alias',
      fieldNotes:         'Notes',
      fieldNotesPlaceholder: 'Internal notes…',
      fieldActive:        'Active',
      saved:              'Saved',
      customerCreated:    'Customer created.',
      customerUpdated:    'Customer updated.',
      customerDeleted:    'Customer removed.',
      saveFailed:         'Save failed.',
      nameDuplicate:      'A customer with this name already exists.',

      // ── Detail header ─────────────────────────────────────────────────────
      kpiRisk:            'Risk',
      kpiWorkflows:       'Workflows',
      kpiStreams:          'Streams',
      kpiPendingMatches:  'Pending Matches',
      badgeActive:        'Active',
      badgeInactive:      'Inactive',

      // ── Tabs ─────────────────────────────────────────────────────────────
      tabStammdaten:   'Master Data',
      tabDetection:    'Detection Set',
      tabExclusions:   'Exclusions',
      tabMatches:      'Matches',
      tabRisk:         'Risk',
      tabEngUsers:     'Enginsight Users',
      tabWebhooks:     'Webhooks',
      tabAlertGroups:  'Alert Groups',

      // ── Tabs (restructured: 5 task-oriented tabs) ─────────────────────────
      tabProfil:       'Profile',
      tabAlerts:       'Alerts',
      tabEvents:       'Events',
      tabSync:         'Sync',
      tabRiskMatches:  'Risk & Matches',
      subWorkflows:    'Workflows',
      subStreams:      'Streams',
      subExclusions:   'Exclusions',

      // ── Detail header: sync KPIs + auto-reload ───────────────────────────
      kpiSetup:         'Setup',
      kpiSynced:        'Synced',
      kpiRules:         'Detection Rules',
      kpiBot:           'Sync Bot',
      botRunning:       'running',
      botStale:         'stale',
      botNever:         'never run',
      botError:         'error',
      botRunningHint:   'The sync bot ran recently and is considered active.',
      botStaleHint:     'No sync activity for a while — the bot may be stopped.',
      botNeverHint:     'Nothing has been synced for this customer yet.',
      botErrorHint:     'The last sync run failed — see the error below. Often a temporary Enginsight timeout/overload; the next run retries.',
      kpiLastRun:       'last run',
      kpiNever:         'never',
      kpiOf:            'of',
      kpiCadence:       'every {0}',
      syncIntervalLabel: 'Interval',
      nothingSetup:     'Nothing set up yet',
      autoReload:       'Auto-refresh',
      autoReloadPause:  'Pause auto-refresh',
      autoReloadResume: 'Resume auto-refresh',
      autoReloadNext:   'next in',
      autoReloadPaused: 'paused',
      syncHealthTitle:  'Sync Bot Status',
      syncErrorShow:    'Show error',
      syncErrorTitle:   'Sync error',
      syncErrorIntro:   'The sync bot reported this error for this item. Often a temporary timeout/overload of the Enginsight instance — the next run retries automatically.',
      syncRunErrorTitle:   'Last sync run failed',
      syncRunErrorIntro:   'The sync bot could not complete the last run for this customer. Items may stay pending until it succeeds.',
      syncRunOkAt:         'Last successful run',
      syncRunErrorAt:      'Failed at',

      // ── Incident contacts ────────────────────────────────────────────────
      contactsTitle:       'Incident Contacts',
      contactsIntro:       'Who to reach — and how — when something happens at this customer.',
      contactsEmpty:       'No contacts yet. Add the people to reach during an incident.',
      contactAddBtn:       'Add contact',
      contactDialogCreate: 'New Contact',
      contactDialogEdit:   'Edit Contact',
      contactName:         'Name',
      contactRole:         'Role',
      contactPriority:     'Priority',
      contactTitle:        'Position',
      contactEmail:        'Email',
      contactPhone:        'Phone',
      contactMobile:       'Mobile',
      contactAvailability: 'Availability',
      contactAvailabilityPlaceholder: 'e.g. Mon–Fri 9–17, on-call 24/7',
      contactNotes:        'Notes',
      contactNameRequired: 'Name is required.',
      contactCreated:      'Contact added.',
      contactUpdated:      'Contact updated.',
      contactDeleted:      'Contact removed.',
      contactConfirmDelete:'Delete this contact?',
      contactSaveFailed:   'Could not save contact.',
      contactLoadFailed:   'Contacts could not be loaded.',
      contactDeleteFailed: 'Could not delete contact.',
      roleTechnical:  'Technical',
      roleBusiness:   'Business',
      roleEmergency:  'Emergency',
      roleBilling:    'Billing',
      roleManagement: 'Management',
      roleOther:      'Other',
      prioPrimary:    'Primary',
      prioSecondary:  'Secondary',
      prioEscalation: 'Escalation',

      // ── Enginsight users (read-only mirror) ──
      engUsersTitle:      'Enginsight users',
      engUsersIntro:      'Read-only mirror of the users in the Enginsight instance. Users are never created or changed here; they are available as alert recipients and responsibles.',
      engUsersLoadFailed: 'Enginsight users could not be loaded.',
      engUsersEmpty:      'No Enginsight users mirrored yet. They appear after the next sync cycle.',
      colEngUserName:     'Name',
      colEngUserEmail:    'Email',
      colEngUserRoles:    'Roles',
      colEngUserBlocked:  'Status',
      colEngUserSynced:   'Synced',
      engBlockedYes:      'Blocked',
      engBlockedNo:       'Active',

      // ── Webhooks ──
      // ── Event back-channel (Enginsight → secDash) ─────────────────────────
      eventsTokenTitle:        'Webhook Connection',
      eventsTokenIntro:        'Generate an ingest token, then enter the URL and the header in this customer\'s Enginsight (or their own n8n). When a workflow triggers, the event appears below in near real-time. The token alone identifies this customer — nothing is ever mixed between customers.',
      eventsActive:            'Active',
      eventsInactive:          'Not configured',
      eventsUrl:               'Webhook URL',
      eventsHeader:            'Header',
      eventsSetAt:             'Token set',
      eventsActivateBtn:       'Activate Webhook',
      eventsRotateBtn:         'Rotate Token',
      eventsRevokeBtn:         'Revoke',
      eventsRotateConfirm:     'Rotating invalidates the current token immediately. The old webhook will stop working until the new token is configured. Continue?',
      eventsRevokeConfirm:     'Revoke the ingest token? Incoming events for this customer will be rejected until a new token is generated.',
      eventsTokenCreated:      'Ingest token generated.',
      eventsTokenRevoked:      'Ingest token revoked.',
      eventsTokenCreateFailed: 'Token could not be generated.',
      eventsTokenRevokeFailed: 'Token could not be revoked.',
      eventsTokenLoadFailed:   'Token status could not be loaded.',
      eventsCopied:            '{what} copied.',
      eventsCopyFailed:        'Copy failed.',
      eventsRevealTitle:       'Your Ingest Token',
      eventsRevealWarn:        'This token is shown only once. Store it now — it cannot be retrieved again.',
      eventsRevealHint:        'Enter the URL as the webhook target in Enginsight and add the header above. Only POST with a JSON body is accepted.',
      eventsToken:             'Token',
      eventsListTitle:         'Received Events',
      eventsListIntro:         'Raw inbound events (learning phase: the full payload is stored as received). Click a row to inspect it.',
      eventsEmpty:             'No events received yet.',
      eventsLoadFailed:        'Events could not be loaded.',
      eventsDetailTitle:       'Event Detail',
      eventsPayload:           'Payload',
      eventsHeaders:           'Headers',
      evColReceived:           'Received',
      evColSource:             'Source IP',
      evColSummary:            'Payload (preview)',
      evColProcessed:          'Status',
      evProcessed:             'Processed',
      evRaw:                   'Raw',
      evView:                  'View',
      eventsStatusOk:          'Workflow events from this customer\'s Enginsight arrive here in near real-time.',
      eventsStatusOff:         'Not configured yet. Activate the secDASH integration under Alerts → Webhooks — the sync bot then registers it in the customer\'s Enginsight automatically.',
      eventsGoActivate:        'Activate under Webhooks',
      evColEvent:              'Event',
      evColSeverity:           'Severity',
      evColStarted:            'Started',
      evColOccur:              'Count',
      evUnparsed:              'Unrecognized format',
      evUnparsedHint:          'This payload does not match the known Enginsight format — shown as raw JSON only.',
      // Header anomaly / tamper detection
      evAnomaly:               'Header anomaly',
      evAnomalyTag:            'Anomaly',
      evAnomalyReason:         'Reason',
      evAnomalyTooltip:        'The request headers differ from Enginsight\'s expected fingerprint. Stored for review but not treated as a clean event.',
      eventsAnomalyBanner:     ({ count } = {}) => count === 1
                                 ? '1 event has a header anomaly — review it below.'
                                 : `${count} events have header anomalies — review them below.`,
      eventsAnomalyOnly:       'Anomalies only',
      eventsParsed:            'Parsed fields',
      evScenario:              'Scenario',
      evSyslog:                'Syslog',
      evHostname:              'Host',
      evOrganisation:          'Organisation',
      evDetected:              'Detected',
      evEnded:                 'Ended',
      evLink:                  'Incident link',
      evResolved:              'Resolved',
      evYes:                   'Yes',
      evNo:                    'No',
      // ── Browser alarm notifications (Settings) ──
      notifTitle:              'Alarm notifications',
      notifEnableLabel:        'Enable alarm notifications',
      notifEnableDesc:         'Get a browser notification when a new customer alarm arrives — as long as a secDASH tab is open.',
      notifPermLabel:          'Browser permission',
      notifPermDesc:           'Notifications require your browser\'s permission. This is per browser/device.',
      notifPermBtn:            'Allow notifications',
      notifPermGranted:        'Granted',
      notifPermDenied:         'Blocked',
      notifPermDefault:        'Not requested',
      notifPermDeniedHint:     'Notifications are blocked. Re-enable them in your browser\'s site settings.',
      notifSeverityLabel:      'Notify for severity',
      notifSeverityDesc:       'Only alarms at or above the selected levels trigger a notification.',
      notifTestDesc:           'Send a sample notification to verify it works.',
      notifTestBtn:            'Send test',
      notifTestBody:           'Test — alarm notifications are active.',
      notifUnsupported:        'Your browser does not support notifications (or you are in the native app, which uses push notifications instead).',
      notifNewAlarm:           'New alarm',
      notifSummaryTitle:       ({ count } = {}) => `${count} new alarms`,
      notifSummaryBody:        'Several new customer alarms arrived.',
      sev_critical:            'Critical',
      sev_high:                'High',
      sev_medium:              'Medium',
      sev_low:                 'Low',
      sev_none:                'None',
      // secDASH integration webhook (Alerts → Webhooks)
      whTypeSecdash:           'secDASH Integration',
      whTypeCustom:            'Custom Webhook',
      whSecdashBadge:          'secDASH',
      whSecdashBadgeHint:      'Managed event back-channel — receives this customer\'s workflow events. Target, header and token are managed automatically.',
      whSecdashRotate:         'Rotate token',
      whSecdashRotateConfirm:  'Rotate the ingest token? The old token stops working immediately; the sync bot pushes the new one to Enginsight on the next run.',
      whSecdashCreated:        'secDASH integration created.',
      whSecdashRotated:        'Token rotated.',
      whSecdashCreateFailed:   'secDASH integration could not be set up.',
      whSecdashRevealTitle:    'secDASH Integration',
      whSecdashRevealNote:     'The sync bot registers this webhook in the customer\'s Enginsight automatically. The values below are for manual setups or reference.',
      whSecdashRevealWarn:     'The token is shown only once here. It is stored in the webhook header and synced automatically.',

      webhooksTitle:      'Webhooks',
      webhooksIntro:      'Define webhooks here; the sync creates and maintains them in Enginsight. They can be attached to alerts.',
      webhooksLoadFailed: 'Webhooks could not be loaded.',
      webhooksEmpty:      'No webhooks yet.',
      webhookAddBtn:      'New Webhook',
      webhookEditTitle:   'Edit Webhook',
      webhookCreateTitle: 'New Webhook',
      colWebhookName:     'Name',
      colWebhookMethod:   'Method',
      colWebhookTarget:   'Target',
      colWebhookSync:     'Sync',
      fieldWebhookName:        'Name',
      fieldWebhookDescription: 'Description',
      fieldWebhookMethod:      'Method',
      fieldWebhookTarget:      'Target URL',
      fieldWebhookContentType: 'Content type',
      fieldWebhookHeaders:     'Headers',
      fieldWebhookPayload:     'Payload',
      webhookHeaderKey:    'Key',
      webhookHeaderValue:  'Value',
      webhookAddHeader:    'Add header',
      webhookDeleteConfirm: 'Delete webhook "{name}"? If already synced it will also be removed in Enginsight.',
      webhookSaved:        'Webhook saved.',
      webhookDeleted:      'Webhook deleted.',
      fieldsRequired:      'Please fill in all required fields.',

      // ── Alert groups ──
      alertGroupsTitle:    'Alert groups',
      alertGroupsIntro:    'Bundle recipients, groups and webhooks. Mark one as default; enabling an alert on a workflow then prefills the default and you only adjust deviations.',
      alertGroupsLoadFailed: 'Alert groups could not be loaded.',
      alertGroupsEmpty:    'No alert groups yet.',
      alertGroupAddBtn:    'New Alert Group',
      alertGroupEditTitle: 'Edit Alert Group',
      alertGroupCreateTitle: 'New Alert Group',
      colAlertGroupName:    'Name',
      colAlertGroupDefault: 'Default',
      colAlertGroupUsers:   'Users',
      colAlertGroupGroups:  'Groups',
      colAlertGroupWebhooks: 'Webhooks',
      fieldAlertGroupName:    'Name',
      fieldAlertGroupDefault: 'Default group',
      fieldAlertGroupUsers:   'Users',
      fieldAlertGroupGroups:  'Groups',
      fieldAlertGroupWebhooks: 'Webhooks',
      fieldAlertOptResponsibles: 'Notify responsibles',
      fieldAlertOptClosure:   'Notify on closure',
      alertGroupDeleteConfirm: 'Delete alert group "{name}"?',
      alertGroupSaved:     'Alert group saved.',
      alertGroupDeleted:   'Alert group deleted.',
      badgeDefault:        'Default',

      // ── Workflow alert + responsibles ──
      colAlert:            'Alert',
      colResponsibles:     'Responsibles',
      alertActive:         'Active',
      alertInactive:       'Off',
      manageAlert:         'Configure alert',
      manageResponsibles:  'Set responsibles',
      workflowAlertTitle:  'Alert for "{name}"',
      fieldAlertEnabled:   'Alert active',
      fieldAlertGroup:     'Apply alert group',
      alertGroupNone:      'Custom (no group)',
      alertDivergesFromDefault: 'Deviates from default group',
      fieldAlertAlias:     'Alias (optional)',
      workflowAlertSaved:  'Alert configuration saved.',
      workflowAlertDeleted: 'Alert removed.',
      alertNoRecipients:   'An alert needs at least one user, group or webhook.',
      responsiblesTitle:   'Responsibles for "{name}"',
      fieldResponsibleWorkflow: 'Workflow responsible',
      fieldResponsibleIncident: 'Incident responsible',
      responsibleNone:     'None',
      responsiblesSaved:   'Responsibles saved.',

      // ── Bulk apply ──
      bulkApplyAction:     'Apply settings',
      bulkApplyTitle:      'Apply settings to {count} workflows',
      bulkApplyTitleStream: 'Apply settings to {count} streams',
      bulkSectionAlert:    'Set alert status',
      bulkSectionResponsibles: 'Set responsibles',
      bulkNothingSelected: 'Select at least one section to apply.',
      bulkApplied:         'Settings applied to {count} workflows.',
      bulkAppliedStream:   'Settings applied to {count} streams.',
      bulkPartialFailed:   '{failed} of {total} workflows could not be updated.',
      bulkPartialFailedStream: '{failed} of {total} streams could not be updated.',
      bulkRemoveConfirm:   'Remove {count} workflows from the detection set?',
      bulkRemoved:         '{count} workflows removed.',
      bulkRemoveStreamsConfirm: 'Remove {count} streams from the detection set?',
      bulkStreamsRemoved:       '{count} streams removed.',
      bulkStreamsRemovedSkipped: '{count} streams removed. {skipped} skipped (used by a workflow).',
      bulkRemoveExclusionsConfirm: 'Delete {count} exclusions?',
      bulkExclusionsRemoved:       '{count} exclusions deleted.',
      bulkEnableAction:    'Enable',
      bulkDisableAction:   'Disable',
      bulkExclusionsEnabled:  '{count} exclusions enabled.',
      bulkExclusionsDisabled: '{count} exclusions disabled.',
      bulkExclusionsUpdateFailed: '{failed} of {total} exclusions could not be updated.',
      bulkRemoveWebhooksConfirm:   'Delete {count} webhooks?',
      bulkWebhooksRemoved:         '{count} webhooks deleted.',
      bulkWebhooksDeleteFailed:    '{failed} of {total} webhooks could not be deleted (possibly still in use).',
      bulkRemoveAlertGroupsConfirm: 'Delete {count} alert groups?',
      bulkAlertGroupsRemoved:       '{count} alert groups deleted.',
      bulkAlertGroupsDeleteFailed:  '{failed} of {total} alert groups could not be deleted.',

      // ── Detection exclusions ──
      exclusionsTitle: 'Detection exclusions',
      exclusionsIntro: 'Define per-customer exceptions once — the sync injects them into every workflow for this customer, so you never re-edit workflows individually.',
      exclusionsLoadFailed: 'Exclusions could not be loaded.',
      exAddBtn: 'Add exclusion',
      exEmpty: 'No exclusions yet.',
      exColScope: 'Scope',
      exColKind: 'Type',
      exColRule: 'Rule',
      exColEnabled: 'Active',
      exColNote: 'Note',
      exScopeCustomer: 'All workflows',
      exScopeWorkflow: 'Single workflow',
      exScopeCustomerHint: 'Applies to every workflow of this customer.',
      exScopeWorkflowHint: 'Applies only to the selected workflow.',
      exKindStructured: 'Structured',
      exKindRaw: 'Raw Lucene',
      exOpNe: 'is not',
      exOpNc: 'does not contain',
      exOpNex: 'does not exist',
      exDialogCreate: 'Add exclusion',
      exDialogEdit: 'Edit exclusion',
      exFieldKind: 'Type',
      exFieldScope: 'Scope',
      exFieldWorkflow: 'Workflow',
      exWorkflowPlaceholder: 'Select workflow',
      exWorkflowEmpty: 'No workflows in the detection set yet.',
      exFieldField: 'Field',
      exFieldOperator: 'Operator',
      exFieldValue: 'Value',
      exFieldRaw: 'Lucene expression',
      exFieldNote: 'Note',
      exNotePlaceholder: 'e.g. test server, no alerting',
      exFieldEnabled: 'Active',
      exStructuredHint: 'Injected as a negated filter into every condition — works for all stream types, including managed streams.',
      exRawHint: 'Appended as "AND NOT (…)" to combination/custom stream queries the bot pushes. Does NOT affect managed streams — use structured for those.',
      exRawScopeHint: 'Raw exclusions always apply customer-wide.',
      exWorkflowRequired: 'Please select a workflow.',
      exFieldRequired: 'Please enter a field.',
      exRawRequired: 'Please enter a Lucene expression.',
      exclusionCreated: 'Exclusion created.',
      exclusionUpdated: 'Exclusion updated.',
      exclusionSaveFailed: 'Save failed.',
      exclusionDeleted: 'Exclusion removed.',
      exclusionDeleteFailed: 'Delete failed.',
      exclusionConfirmDelete: 'Really delete this exclusion?',

      // ── Detection Set tab ─────────────────────────────────────────────────
      workflowsTitle:      'Assigned Workflows',
      streamsTitle:        'Assigned Streams',
      addWorkflowsBtn:     'Add Workflows',
      streamsAutoAdded:    'Workflow(s) added. Custom/wrapper streams were automatically added to the streams list so their sync status is visible.',
      streamsWrappedInfo:  '{count} managed stream(s) were added as customizable wrapper streams (so you can set incidents, alarms and exceptions on them).',
      addStreamsBtn:       'Add Streams',
      removeWorkflowTip:   'Remove workflow',
      removeStreamTip:     'Remove stream',
      streamRemoveWorkflowBacked: 'This stream belongs to a workflow in the detection set and cannot be removed individually — remove the workflow instead.',
      detectionLoadFailed: 'Detection set could not be loaded.',
      workflowPickerTitle: 'Add Workflows',
      workflowPickerHint: 'Only workflows with at least one linked stream are shown. Workflows without streams cannot be synced to Enginsight.',
      streamPickerTitle:   'Add Streams',
      pickerSearchPlaceholder: 'Search…',
      pickerAddBtn:        'Add selected',
      pickerEmpty:         'No items found.',
      pickerTabManaged:    'Managed catalogs',
      pickerTabCustom:     'My streams',
      pickerUncategorized: 'Uncategorized',
      pickerCatCount:      '{count} entries',
      pickerSelectCatalog: 'Select a catalog to view its entries',
      pickerSelectAllInGroup: 'Select all in this category',
      pickerSelectedCount: '{count} selected',
      pickerCapped:        'Showing the first results — use the tabs or search to narrow down.',
      streamWrapperBadge:  'Wrapper',
      addFailed:           'Could not add items.',
      removeFailed:        'Could not remove item.',
      colWorkflowName:     'Workflow',
      colWorkflowSeverity: 'Severity',
      colWorkflowVis:      'Visibility',
      colStreamName:       'Stream',
      colStreamCategory:   'Category',
      colStreamType:       'Type',
      colAddedAt:          'Added',
      colSyncStatus:       'Sync',
      colEnginsightGuid:   'Enginsight ID',
      sync_pending:        'Pending',
      sync_synced:         'Synced',
      sync_error:          'Error',
      sync_pending_delete: 'Removing…',
      streamManaged:       'Managed',
      streamCustom:        'Custom',
      streamManagedHint:   'Managed stream — already present on every Enginsight instance, no sync needed.',
      streamManagedSyncHint: 'Managed streams exist natively on Enginsight — no sync required.',

      // ── Stream incidents (events) ─────────────────────────────────────────
      colStreamIncidents:  'Events',
      incOn:               'On',
      incOff:              'Off',
      streamIncidentsTip:  'Configure events',
      streamIncidentsWorkflowBacked: 'A workflow in the detection set already processes this stream — events are generated by the workflow.',
      streamManagedIncidentsHint: 'Managed streams cannot carry event settings. Create a wrapper stream that references it and configure events on the wrapper.',
      streamIncidentsTitle: 'Events — {name}',
      streamIncidentsHint: 'Controls whether and how Enginsight raises incidents directly from this stream. This is separate from stream alerts (notifications).',
      streamIncidentsSaved: 'Event settings saved.',
      incEnabled:          'Trigger events directly',
      incCooldownValue:    'Event delay',
      incCooldownUnit:     'Unit',
      incCooldownZeroHint: '0 = no delay',
      incCooldownUnit_sec:  'Seconds',
      incCooldownUnit_min:  'Minutes',
      incCooldownUnit_hour: 'Hours',
      incCooldownUnit_day:  'Days',
      incCooldownUnit_week: 'Weeks',
      incGroups:           'Grouping',
      incGroupsHint:       'Group events by field, e.g. gen.hostname. Type and press Enter to add.',
      incSchedule:         'Event window (cron)',
      incScheduleAdd:      'Add window',
      incScheduleHint:     'Cron expression + IANA timezone, e.g. "* 8-18 * * 1-5" / Europe/Berlin.',
      incSeverity:         'Severity override',
      incSeverityDefault:  'Default (medium)',
      // Stream alert (belongsTo: siemStream) — separate from incidents, own dialog
      colStreamAlert:        'Alert',
      streamAlertTitle:      'Stream alarm – {name}',
      streamAlertMode:       'Binding',
      streamAlertModeStream: 'This stream',
      streamAlertModeTag:    'All streams with tag',
      streamAlertNoTags:     'This stream has no tags — only a per-stream alarm is possible.',
      streamAlertTag:        'Tag',
      streamAlertTagScope:   'Applies to ALL streams with the tag »{tag}« — not only this one.',
      streamAlertPickTag:    'Please select a tag.',
      streamAlertSaved:      'Stream alarm saved.',
      streamAlertDeleted:    'Stream alarm deleted.',
      streamAlertPerStream:  'Per-stream alarm active',
      streamAlertViaTag:     'Active via tag: {tags}',
      streamAlertEnablesEvents: 'Enabling the alarm also enables this stream’s events (required — the alarm only fires on events).',
      streamAlertTagEventsHint: 'The alarm only fires for tagged streams that have events enabled.',
      streamAlertWorkflowBacked: 'A workflow in the detection set already raises the alert for this stream — no separate stream alarm needed.',

      // ── Matches tab ───────────────────────────────────────────────────────
      matchesTitle:         'Hack Post Matches',
      matchFilterAll:       'All',
      matchFilterPending:   'Pending',
      matchFilterConfirmed: 'Confirmed',
      matchFilterRejected:  'Rejected',
      colMatchPost:         'Post',
      colMatchGroup:        'Threat Actor',
      colMatchScore:        'Confidence',
      colMatchSeverity:     'Severity',
      colMatchStatus:       'Status',
      colMatchDate:         'Date',
      colMatchActions:      'Actions',
      confirmMatchTip:      'Confirm match',
      rejectMatchTip:       'Reject match',
      confirmDialogTitle:   'Confirm Match',
      confirmDialogBody:    'Confirm that "{title}" is a match for this customer?',
      confirmSeverityLabel: 'Severity (optional override)',
      confirmBtn:           'Confirm',
      rejectBtn:            'Reject',
      matchConfirmed:       'Match confirmed.',
      matchRejected:        'Match rejected.',
      matchReviewFailed:    'Review failed.',
      matchesLoadFailed:    'Matches could not be loaded.',
      matchesEmpty:         'No match candidates yet. Once a hack post is matched to this customer, it will appear here.',

      // ── Risk tab ─────────────────────────────────────────────────────────
      riskTitle:            'Risk Score',
      riskSeverityLabel:    'Current Severity',
      riskLookback:         'Time window',
      riskLookback7:        'Last 7 days',
      riskLookback14:       'Last 14 days',
      riskLookback30:       'Last 30 days',
      riskLookback90:       'Last 90 days',
      riskDerivedMatches:   'Based on confirmed matches',
      riskDerivedContext:   'Based on sector / country activity',
      riskDerivedManual:    'Manually set',
      riskDerivedEscalated: 'Auto-escalated (override superseded)',
      riskColScore:         'Score',
      riskTrendTitle:       'Risk Trend',
      riskTrendEmpty:       'Not enough data for a trend chart yet (min. 7 days).',
      riskLoadFailed:       'Risk score could not be loaded.',
      riskAutoLabel:        'Computed',
      riskManualBadge:      'Manual',
      riskManualHint:       'This risk score was set manually and overrides the computed value.',
      riskManualSetBy:      'Set by',
      riskOverrideSetBtn:   'Set manually',
      riskOverrideEditBtn:  'Edit override',
      riskOverrideClearBtn: 'Reset to automatic',
      riskOverrideClearHint: 'Remove the manual override; the computed score takes over again.',
      riskOverrideDialogTitle: 'Manual risk override',
      riskOverrideIntro:    'Pin the risk severity for this customer. The manual value overrides the automatically computed score until you reset it.',
      riskOverrideNoteLabel: 'Reason / note',
      riskOverrideNotePlaceholder: 'Why is this risk raised or lowered?',
      riskOverrideSaved:    'Manual risk override saved.',
      riskOverrideSaveFailed: 'Risk override could not be saved.',
      riskOverrideCleared:  'Manual override removed — automatic score active again.',
      riskOverrideClearFailed: 'Override could not be removed.',
      riskOverrideClearConfirm: 'Reset the risk to the automatically computed score?',
      riskSupersededBadge:  'Override superseded',
      riskSupersededHint:   'The automatic score has escalated above the level when the override was set — the higher automatic value is shown.',
      riskSupersededNote:   'Your manual value ({manual}) was superseded: the automatic assessment escalated to {auto}. Re-confirm to set a new baseline, or reset to automatic.',
      riskReviewBadge:      'Re-evaluate',
      riskReviewHint:       'The review date for this manual override has passed — please re-assess.',
      riskBaselineLabel:    'Baseline',
      riskReviewAtLabel:    'Review on',
      riskReviewLabel:      'Re-evaluation reminder',
      riskReview7:          'In 7 days',
      riskReview30:         'In 30 days',
      riskReview90:         'In 90 days',
      riskReviewNone:       'No reminder',
      riskEscalationHint:   'The override does not freeze the risk: if the automatic score escalates above its current level (new match, rising sector/country activity), the higher automatic value takes over again.',

      // ── Severity labels ───────────────────────────────────────────────────
      sevCritical: 'Critical',
      sevHigh:     'High',
      sevMedium:   'Medium',
      sevLow:      'Low',
      sevNone:     'None',

      // ── Employee bucket labels ────────────────────────────────────────────
      bucket_1_49:      '1 - 49',
      bucket_50_249:    '50 - 249',
      bucket_250_999:   '250 - 999',
      bucket_1000_4999: '1,000 - 4,999',
      bucket_5000:      '5,000+',
    },
  },

  de: {
    partnerCustomers: {
      // ── Nav ───────────────────────────────────────────────────────────────
      navTitle:    'Kunden',
      navOverview: 'Übersicht',

      // ── Overview ─────────────────────────────────────────────────────────
      overviewTitle:       'Managed Detection Service',
      overviewDescription: 'Ueberwachen Sie die Cyberrisiko-Exposition Ihrer Kunden. Bestaetigte Hack-Post-Matches treiben den Risikowert; Sektor- und Landaktivitaet liefert kontextuelles Risiko wenn keine direkten Matches vorliegen.',
      kpiTotal:            'Kunden gesamt',
      kpiActive:           'Aktiv',
      kpiWithWorkflows:    'Mit Workflows',
      kpiConfirmedMatches: 'Bestaetigte Matches',
      kpiPendingMatches2:  'Ausstehend',
      top10Title:          'Top 10 gefaehrdetste Kunden',
      top10Empty:          'Noch keine Risikodaten. Workflow starten oder naechsten Zyklus abwarten.',
      colRank:             '#',
      colConfirmedMatches: 'Bestaetigt',
      colPendingMatches:   'Ausstehend',
      toListBtn:           'Alle Kunden →',

      // ── List view ─────────────────────────────────────────────────────────
      pageTitle:   'Kunden',
      addBtn:      'Neuer Kunde',
      searchPlaceholder: 'Nach Name suchen…',
      colName:         'Name',
      colIndustry:     'Branche',
      colCountry:      'Land',
      colSize:         'Groesse',
      colWorkflows:    'Workflows',
      colRisk:         'Risiko',
      colActive:       'Aktiv',
      colActions:      'Aktionen',
      editTooltip:     'Bearbeiten',
      deleteTooltip:   'Loschen',
      emptyState:      'Noch keine Kunden vorhanden. Legen Sie Ihren ersten Kunden an.',
      loadFailed:      'Kunden konnten nicht geladen werden.',
      filterRisk:      'Risiko',
      filterIndustry:  'Branche',
      filterAll:       'Alle',
      filterActive:    'Nur aktive',
      deleteFailed:    'Loschen fehlgeschlagen.',
      deleteConfirm:   'Kunden "{name}" und alle zugehoerigen Daten loeschen? Dieser Vorgang kann nicht rueckgaengig gemacht werden.',

      // ── Create / Edit dialog ──────────────────────────────────────────────
      dialogCreate:       'Neuer Kunde',
      dialogEdit:         'Kunde bearbeiten',
      fieldName:          'Name',
      fieldNamePlaceholder:'Unternehmensname',
      fieldCountry:       'Land (ISO-2)',
      fieldCountryPlaceholder: 'z.B. DE',
      fieldIndustry:      'Branche',
      fieldIndustryPlaceholder: 'Branche auswaehlen',
      fieldSize:          'Unternehmensgroesse',
      fieldSizePlaceholder:    'Groesse auswaehlen',
      fieldExternalId:    'Externe ID',
      fieldExternalIdPlaceholder: 'z.B. Kunden-ID',
      fieldDomains:       'Domains',
      fieldDomainsPlaceholder: 'z.B. acme.de',
      fieldDomainsHint:   'Enter druecken um Domain hinzuzufuegen',
      fieldAliases:       'Aliases',
      fieldAliasesPlaceholder: 'Alternative Firmennamen',
      fieldAliasesHint:   'Enter druecken um Alias hinzuzufuegen',
      fieldNotes:         'Notizen',
      fieldNotesPlaceholder: 'Interne Notizen…',
      fieldActive:        'Aktiv',
      saved:              'Gespeichert',
      customerCreated:    'Kunde angelegt.',
      customerUpdated:    'Kunde gespeichert.',
      customerDeleted:    'Kunde entfernt.',
      saveFailed:         'Speichern fehlgeschlagen.',
      nameDuplicate:      'Ein Kunde mit diesem Namen existiert bereits.',

      // ── Detail header ─────────────────────────────────────────────────────
      kpiRisk:            'Risiko',
      kpiWorkflows:       'Workflows',
      kpiStreams:          'Streams',
      kpiPendingMatches:  'Offene Matches',
      badgeActive:        'Aktiv',
      badgeInactive:      'Inaktiv',

      // ── Tabs ─────────────────────────────────────────────────────────────
      tabStammdaten:   'Stammdaten',
      tabDetection:    'Detection-Set',
      tabExclusions:   'Ausnahmen',
      tabMatches:      'Matches',
      tabRisk:         'Risiko',
      tabEngUsers:     'Enginsight Benutzer',
      tabWebhooks:     'Webhooks',
      tabAlertGroups:  'Alarm-Gruppen',

      // ── Tabs (neu strukturiert: 5 aufgabenorientierte Tabs) ───────────────
      tabProfil:       'Profil',
      tabAlerts:       'Alarme',
      tabEvents:       'Ereignisse',
      tabSync:         'Sync',
      tabRiskMatches:  'Risiko & Matches',
      subWorkflows:    'Workflows',
      subStreams:      'Streams',
      subExclusions:   'Ausnahmen',

      // ── Detail-Header: Sync-KPIs + Auto-Reload ───────────────────────────
      kpiSetup:         'Eingerichtet',
      kpiSynced:        'Gesynct',
      kpiRules:         'Detection Rules',
      kpiBot:           'Sync-Bot',
      botRunning:       'läuft',
      botStale:         'inaktiv',
      botNever:         'nie gelaufen',
      botError:         'Fehler',
      botRunningHint:   'Der Sync-Bot lief kürzlich und gilt als aktiv.',
      botStaleHint:     'Seit längerem keine Sync-Aktivität — der Bot steht möglicherweise still.',
      botNeverHint:     'Für diesen Kunden wurde noch nichts synchronisiert.',
      botErrorHint:     'Der letzte Sync-Lauf ist fehlgeschlagen — Details siehe unten. Oft ein vorübergehender Enginsight-Timeout/Überlastung; der nächste Lauf versucht es erneut.',
      kpiLastRun:       'letzter Run',
      kpiNever:         'nie',
      kpiOf:            'von',
      kpiCadence:       'alle {0}',
      syncIntervalLabel: 'Intervall',
      nothingSetup:     'Noch nichts eingerichtet',
      autoReload:       'Auto-Aktualisierung',
      autoReloadPause:  'Auto-Aktualisierung pausieren',
      autoReloadResume: 'Auto-Aktualisierung fortsetzen',
      autoReloadNext:   'nächste in',
      autoReloadPaused: 'pausiert',
      syncHealthTitle:  'Sync-Bot Status',
      syncErrorShow:    'Fehler anzeigen',
      syncErrorTitle:   'Sync-Fehler',
      syncErrorIntro:   'Der Sync-Bot hat diesen Fehler für dieses Element gemeldet. Oft ein vorübergehender Timeout/Überlastung der Enginsight-Instanz — der nächste Lauf versucht es automatisch erneut.',
      syncRunErrorTitle:   'Letzter Sync-Lauf fehlgeschlagen',
      syncRunErrorIntro:   'Der Sync-Bot konnte den letzten Lauf für diesen Kunden nicht abschließen. Elemente bleiben evtl. auf „ausstehend", bis er durchläuft.',
      syncRunOkAt:         'Letzter erfolgreicher Lauf',
      syncRunErrorAt:      'Fehlgeschlagen um',

      // ── Incident-Kontakte ────────────────────────────────────────────────
      contactsTitle:       'Incident-Kontakte',
      contactsIntro:       'Wer im Ernstfall bei diesem Kunden erreichbar ist — und wie.',
      contactsEmpty:       'Noch keine Kontakte. Hinterlege die Ansprechpartner für den Incident-Fall.',
      contactAddBtn:       'Kontakt hinzufügen',
      contactDialogCreate: 'Neuer Kontakt',
      contactDialogEdit:   'Kontakt bearbeiten',
      contactName:         'Name',
      contactRole:         'Rolle',
      contactPriority:     'Priorität',
      contactTitle:        'Position',
      contactEmail:        'E-Mail',
      contactPhone:        'Telefon',
      contactMobile:       'Mobil',
      contactAvailability: 'Erreichbarkeit',
      contactAvailabilityPlaceholder: 'z. B. Mo–Fr 9–17, Bereitschaft 24/7',
      contactNotes:        'Notizen',
      contactNameRequired: 'Name ist erforderlich.',
      contactCreated:      'Kontakt hinzugefügt.',
      contactUpdated:      'Kontakt aktualisiert.',
      contactDeleted:      'Kontakt entfernt.',
      contactConfirmDelete:'Diesen Kontakt löschen?',
      contactSaveFailed:   'Kontakt konnte nicht gespeichert werden.',
      contactLoadFailed:   'Kontakte konnten nicht geladen werden.',
      contactDeleteFailed: 'Kontakt konnte nicht gelöscht werden.',
      roleTechnical:  'Technisch',
      roleBusiness:   'Fachlich',
      roleEmergency:  'Notfall',
      roleBilling:    'Abrechnung',
      roleManagement: 'Management',
      roleOther:      'Sonstige',
      prioPrimary:    'Primär',
      prioSecondary:  'Sekundär',
      prioEscalation: 'Eskalation',

      // ── Enginsight-Benutzer (read-only Spiegel) ──
      engUsersTitle:      'Enginsight Benutzer',
      engUsersIntro:      'Read-only Spiegel der Benutzer der Enginsight-Instanz. Hier werden nie Benutzer angelegt oder geändert; sie stehen als Alarm-Empfänger und Verantwortliche zur Verfügung.',
      engUsersLoadFailed: 'Enginsight Benutzer konnten nicht geladen werden.',
      engUsersEmpty:      'Noch keine Enginsight Benutzer gespiegelt. Sie erscheinen nach dem nächsten Sync-Zyklus.',
      colEngUserName:     'Name',
      colEngUserEmail:    'E-Mail',
      colEngUserRoles:    'Rollen',
      colEngUserBlocked:  'Status',
      colEngUserSynced:   'Gesynct',
      engBlockedYes:      'Gesperrt',
      engBlockedNo:       'Aktiv',

      // ── Webhooks ──
      // ── Event-Rückkanal (Enginsight → secDash) ────────────────────────────
      eventsTokenTitle:        'Webhook-Verbindung',
      eventsTokenIntro:        'Erzeuge ein Ingest-Token und trage anschließend URL und Header in der Enginsight dieses Kunden (oder seinem eigenen n8n) ein. Löst ein Workflow aus, erscheint das Ereignis unten nahezu in Echtzeit. Allein das Token identifiziert diesen Kunden — zwischen Kunden wird nie etwas vermischt.',
      eventsActive:            'Aktiv',
      eventsInactive:          'Nicht eingerichtet',
      eventsUrl:               'Webhook-URL',
      eventsHeader:            'Header',
      eventsSetAt:             'Token gesetzt',
      eventsActivateBtn:       'Webhook aktivieren',
      eventsRotateBtn:         'Token rotieren',
      eventsRevokeBtn:         'Widerrufen',
      eventsRotateConfirm:     'Eine Rotation macht das aktuelle Token sofort ungültig. Der alte Webhook funktioniert nicht mehr, bis das neue Token eingetragen ist. Fortfahren?',
      eventsRevokeConfirm:     'Ingest-Token widerrufen? Eingehende Ereignisse dieses Kunden werden abgelehnt, bis ein neues Token erzeugt wird.',
      eventsTokenCreated:      'Ingest-Token erzeugt.',
      eventsTokenRevoked:      'Ingest-Token widerrufen.',
      eventsTokenCreateFailed: 'Token konnte nicht erzeugt werden.',
      eventsTokenRevokeFailed: 'Token konnte nicht widerrufen werden.',
      eventsTokenLoadFailed:   'Token-Status konnte nicht geladen werden.',
      eventsCopied:            '{what} kopiert.',
      eventsCopyFailed:        'Kopieren fehlgeschlagen.',
      eventsRevealTitle:       'Dein Ingest-Token',
      eventsRevealWarn:        'Dieses Token wird nur einmal angezeigt. Jetzt sichern — es kann später nicht erneut abgerufen werden.',
      eventsRevealHint:        'Trage die URL als Webhook-Ziel in Enginsight ein und ergänze den Header oben. Akzeptiert wird ausschließlich POST mit JSON-Body.',
      eventsToken:             'Token',
      eventsListTitle:         'Empfangene Ereignisse',
      eventsListIntro:         'Rohe eingehende Ereignisse (Lernphase: die volle Payload wird unverändert gespeichert). Zeile anklicken zum Ansehen.',
      eventsEmpty:             'Noch keine Ereignisse empfangen.',
      eventsLoadFailed:        'Ereignisse konnten nicht geladen werden.',
      eventsDetailTitle:       'Ereignis-Detail',
      eventsPayload:           'Payload',
      eventsHeaders:           'Header',
      evColReceived:           'Empfangen',
      evColSource:             'Quell-IP',
      evColSummary:            'Payload (Vorschau)',
      evColProcessed:          'Status',
      evProcessed:             'Verarbeitet',
      evRaw:                   'Roh',
      evView:                  'Ansehen',
      eventsStatusOk:          'Workflow-Ereignisse aus der Enginsight dieses Kunden treffen hier nahezu in Echtzeit ein.',
      eventsStatusOff:         'Noch nicht eingerichtet. Aktiviere die secDASH-Integration unter Alarme → Webhooks — der Sync-Bot legt sie dann automatisch in der Enginsight des Kunden an.',
      eventsGoActivate:        'Unter Webhooks aktivieren',
      evColEvent:              'Ereignis',
      evColSeverity:           'Schweregrad',
      evColStarted:            'Begonnen',
      evColOccur:              'Anzahl',
      evUnparsed:              'Unbekanntes Format',
      evUnparsedHint:          'Diese Payload entspricht nicht dem bekannten Enginsight-Format — wird nur als Roh-JSON angezeigt.',
      // Header-Anomalie / Manipulationserkennung
      evAnomaly:               'Header-Anomalie',
      evAnomalyTag:            'Anomalie',
      evAnomalyReason:         'Grund',
      evAnomalyTooltip:        'Die Request-Header weichen vom erwarteten Enginsight-Fingerabdruck ab. Zur Prüfung gespeichert, aber nicht als sauberes Ereignis behandelt.',
      eventsAnomalyBanner:     ({ count } = {}) => count === 1
                                 ? '1 Ereignis weist eine Header-Anomalie auf — bitte unten prüfen.'
                                 : `${count} Ereignisse weisen Header-Anomalien auf — bitte unten prüfen.`,
      eventsAnomalyOnly:       'Nur Anomalien',
      eventsParsed:            'Geparste Felder',
      evScenario:              'Szenario',
      evSyslog:                'Syslog',
      evHostname:              'Host',
      evOrganisation:          'Organisation',
      evDetected:              'Erkannt',
      evEnded:                 'Beendet',
      evLink:                  'Incident-Link',
      evResolved:              'Behoben',
      evYes:                   'Ja',
      evNo:                    'Nein',
      // ── Browser-Alarm-Benachrichtigungen (Einstellungen) ──
      notifTitle:              'Alarm-Benachrichtigungen',
      notifEnableLabel:        'Alarm-Benachrichtigungen aktivieren',
      notifEnableDesc:         'Erhalte eine Browser-Benachrichtigung bei jedem neuen Kunden-Alarm — solange ein secDASH-Tab geöffnet ist.',
      notifPermLabel:          'Browser-Berechtigung',
      notifPermDesc:           'Benachrichtigungen brauchen die Erlaubnis deines Browsers. Diese gilt pro Browser/Gerät.',
      notifPermBtn:            'Benachrichtigungen erlauben',
      notifPermGranted:        'Erteilt',
      notifPermDenied:         'Blockiert',
      notifPermDefault:        'Nicht angefragt',
      notifPermDeniedHint:     'Benachrichtigungen sind blockiert. Aktiviere sie in den Seiten-Einstellungen deines Browsers erneut.',
      notifSeverityLabel:      'Benachrichtigen ab Schweregrad',
      notifSeverityDesc:       'Nur Alarme der ausgewählten Stufen lösen eine Benachrichtigung aus.',
      notifTestDesc:           'Eine Beispiel-Benachrichtigung senden, um den Empfang zu prüfen.',
      notifTestBtn:            'Test senden',
      notifTestBody:           'Test — Alarm-Benachrichtigungen sind aktiv.',
      notifUnsupported:        'Dein Browser unterstützt keine Benachrichtigungen (oder du bist in der nativen App, die stattdessen Push-Benachrichtigungen nutzt).',
      notifNewAlarm:           'Neuer Alarm',
      notifSummaryTitle:       ({ count } = {}) => `${count} neue Alarme`,
      notifSummaryBody:        'Mehrere neue Kunden-Alarme eingegangen.',
      sev_critical:            'Kritisch',
      sev_high:                'Hoch',
      sev_medium:              'Mittel',
      sev_low:                 'Niedrig',
      sev_none:                'Keine',
      // secDASH-Integration-Webhook (Alarme → Webhooks)
      whTypeSecdash:           'secDASH Integration',
      whTypeCustom:            'Custom Webhook',
      whSecdashBadge:          'secDASH',
      whSecdashBadgeHint:      'Managed Event-Rückkanal — empfängt die Workflow-Ereignisse dieses Kunden. Target, Header und Token werden automatisch verwaltet.',
      whSecdashRotate:         'Token rotieren',
      whSecdashRotateConfirm:  'Ingest-Token rotieren? Das alte Token wird sofort ungültig; der Sync-Bot pusht das neue beim nächsten Lauf nach Enginsight.',
      whSecdashCreated:        'secDASH-Integration angelegt.',
      whSecdashRotated:        'Token rotiert.',
      whSecdashCreateFailed:   'secDASH-Integration konnte nicht eingerichtet werden.',
      whSecdashRevealTitle:    'secDASH Integration',
      whSecdashRevealNote:     'Der Sync-Bot legt diesen Webhook automatisch in der Enginsight des Kunden an. Die Werte unten sind für manuelle Einrichtung oder als Referenz.',
      whSecdashRevealWarn:     'Das Token wird hier nur einmal angezeigt. Es ist im Webhook-Header gespeichert und wird automatisch synchronisiert.',

      webhooksTitle:      'Webhooks',
      webhooksIntro:      'Webhooks hier definieren; der Sync legt sie in Enginsight an und hält sie aktuell. Sie können Alarmen zugeordnet werden.',
      webhooksLoadFailed: 'Webhooks konnten nicht geladen werden.',
      webhooksEmpty:      'Noch keine Webhooks vorhanden.',
      webhookAddBtn:      'Neuer Webhook',
      webhookEditTitle:   'Webhook bearbeiten',
      webhookCreateTitle: 'Neuer Webhook',
      colWebhookName:     'Name',
      colWebhookMethod:   'Methode',
      colWebhookTarget:   'Ziel',
      colWebhookSync:     'Sync',
      fieldWebhookName:        'Name',
      fieldWebhookDescription: 'Beschreibung',
      fieldWebhookMethod:      'Methode',
      fieldWebhookTarget:      'Ziel-URL',
      fieldWebhookContentType: 'Content-Type',
      fieldWebhookHeaders:     'Header',
      fieldWebhookPayload:     'Payload',
      webhookHeaderKey:    'Key',
      webhookHeaderValue:  'Wert',
      webhookAddHeader:    'Header hinzufügen',
      webhookDeleteConfirm: 'Webhook "{name}" löschen? Falls bereits gesynct, wird er auch in Enginsight entfernt.',
      webhookSaved:        'Webhook gespeichert.',
      webhookDeleted:      'Webhook gelöscht.',
      fieldsRequired:      'Bitte alle Pflichtfelder ausfüllen.',

      // ── Alarm-Gruppen ──
      alertGroupsTitle:    'Alarm-Gruppen',
      alertGroupsIntro:    'Empfänger, Gruppen und Webhooks bündeln. Eine als Default markieren; beim Aktivieren eines Workflow-Alarms wird der Default vorbefüllt und nur Abweichungen müssen angepasst werden.',
      alertGroupsLoadFailed: 'Alarm-Gruppen konnten nicht geladen werden.',
      alertGroupsEmpty:    'Noch keine Alarm-Gruppen vorhanden.',
      alertGroupAddBtn:    'Neue Alarm-Gruppe',
      alertGroupEditTitle: 'Alarm-Gruppe bearbeiten',
      alertGroupCreateTitle: 'Neue Alarm-Gruppe',
      colAlertGroupName:    'Name',
      colAlertGroupDefault: 'Default',
      colAlertGroupUsers:   'Benutzer',
      colAlertGroupGroups:  'Gruppen',
      colAlertGroupWebhooks: 'Webhooks',
      fieldAlertGroupName:    'Name',
      fieldAlertGroupDefault: 'Default-Gruppe',
      fieldAlertGroupUsers:   'Benutzer',
      fieldAlertGroupGroups:  'Gruppen',
      fieldAlertGroupWebhooks: 'Webhooks',
      fieldAlertOptResponsibles: 'Verantwortliche benachrichtigen',
      fieldAlertOptClosure:   'Bei Schließung benachrichtigen',
      alertGroupDeleteConfirm: 'Alarm-Gruppe "{name}" löschen?',
      alertGroupSaved:     'Alarm-Gruppe gespeichert.',
      alertGroupDeleted:   'Alarm-Gruppe gelöscht.',
      badgeDefault:        'Default',

      // ── Workflow-Alarm + Verantwortliche ──
      colAlert:            'Alarm',
      colResponsibles:     'Verantwortliche',
      alertActive:         'Aktiv',
      alertInactive:       'Aus',
      manageAlert:         'Alarm konfigurieren',
      manageResponsibles:  'Verantwortliche setzen',
      workflowAlertTitle:  'Alarm für "{name}"',
      fieldAlertEnabled:   'Alarm aktiv',
      fieldAlertGroup:     'Alarm-Gruppe anwenden',
      alertGroupNone:      'Individuell (keine Gruppe)',
      alertDivergesFromDefault: 'Weicht von Default-Gruppe ab',
      fieldAlertAlias:     'Alias (optional)',
      workflowAlertSaved:  'Alarm-Konfiguration gespeichert.',
      workflowAlertDeleted: 'Alarm entfernt.',
      alertNoRecipients:   'Ein Alarm braucht mindestens einen Benutzer, eine Gruppe oder einen Webhook.',
      responsiblesTitle:   'Verantwortliche für "{name}"',
      fieldResponsibleWorkflow: 'Workflow-Verantwortlicher',
      fieldResponsibleIncident: 'Incident-Verantwortlicher',
      responsibleNone:     'Keiner',
      responsiblesSaved:   'Verantwortliche gespeichert.',

      // ── Bulk apply ──
      bulkApplyAction:     'Einstellungen anwenden',
      bulkApplyTitle:      'Einstellungen auf {count} Workflows anwenden',
      bulkApplyTitleStream: 'Einstellungen auf {count} Streams anwenden',
      bulkSectionAlert:    'Alarm-Status setzen',
      bulkSectionResponsibles: 'Verantwortliche setzen',
      bulkNothingSelected: 'Mindestens einen Bereich zum Anwenden wählen.',
      bulkApplied:         'Einstellungen auf {count} Workflows angewendet.',
      bulkAppliedStream:   'Einstellungen auf {count} Streams angewendet.',
      bulkPartialFailed:   '{failed} von {total} Workflows konnten nicht aktualisiert werden.',
      bulkPartialFailedStream: '{failed} von {total} Streams konnten nicht aktualisiert werden.',
      bulkRemoveConfirm:   '{count} Workflows aus dem Detection-Set entfernen?',
      bulkRemoved:         '{count} Workflows entfernt.',
      bulkRemoveStreamsConfirm: '{count} Streams aus dem Detection-Set entfernen?',
      bulkStreamsRemoved:       '{count} Streams entfernt.',
      bulkStreamsRemovedSkipped: '{count} Streams entfernt. {skipped} übersprungen (von einem Workflow genutzt).',
      bulkRemoveExclusionsConfirm: '{count} Ausnahmen löschen?',
      bulkExclusionsRemoved:       '{count} Ausnahmen gelöscht.',
      bulkEnableAction:    'Aktivieren',
      bulkDisableAction:   'Deaktivieren',
      bulkExclusionsEnabled:  '{count} Ausnahmen aktiviert.',
      bulkExclusionsDisabled: '{count} Ausnahmen deaktiviert.',
      bulkExclusionsUpdateFailed: '{failed} von {total} Ausnahmen konnten nicht aktualisiert werden.',
      bulkRemoveWebhooksConfirm:   '{count} Webhooks löschen?',
      bulkWebhooksRemoved:         '{count} Webhooks gelöscht.',
      bulkWebhooksDeleteFailed:    '{failed} von {total} Webhooks konnten nicht gelöscht werden (evtl. noch in Verwendung).',
      bulkRemoveAlertGroupsConfirm: '{count} Alarm-Gruppen löschen?',
      bulkAlertGroupsRemoved:       '{count} Alarm-Gruppen gelöscht.',
      bulkAlertGroupsDeleteFailed:  '{failed} von {total} Alarm-Gruppen konnten nicht gelöscht werden.',

      // ── Detection-Ausnahmen ──
      exclusionsTitle: 'Detection-Ausnahmen',
      exclusionsIntro: 'Ausnahmen einmal pro Kunde definieren — der Sync injiziert sie in jeden Workflow dieses Kunden, sodass du Workflows nie einzeln nachjustieren musst.',
      exclusionsLoadFailed: 'Ausnahmen konnten nicht geladen werden.',
      exAddBtn: 'Ausnahme hinzufügen',
      exEmpty: 'Noch keine Ausnahmen.',
      exColScope: 'Geltungsbereich',
      exColKind: 'Typ',
      exColRule: 'Regel',
      exColEnabled: 'Aktiv',
      exColNote: 'Notiz',
      exScopeCustomer: 'Alle Workflows',
      exScopeWorkflow: 'Einzelner Workflow',
      exScopeCustomerHint: 'Gilt für jeden Workflow dieses Kunden.',
      exScopeWorkflowHint: 'Gilt nur für den gewählten Workflow.',
      exKindStructured: 'Strukturiert',
      exKindRaw: 'Roh-Lucene',
      exOpNe: 'ist nicht',
      exOpNc: 'enthält nicht',
      exOpNex: 'existiert nicht',
      exDialogCreate: 'Ausnahme hinzufügen',
      exDialogEdit: 'Ausnahme bearbeiten',
      exFieldKind: 'Typ',
      exFieldScope: 'Geltungsbereich',
      exFieldWorkflow: 'Workflow',
      exWorkflowPlaceholder: 'Workflow wählen',
      exWorkflowEmpty: 'Noch keine Workflows im Detection-Set.',
      exFieldField: 'Feld',
      exFieldOperator: 'Operator',
      exFieldValue: 'Wert',
      exFieldRaw: 'Lucene-Ausdruck',
      exFieldNote: 'Notiz',
      exNotePlaceholder: 'z. B. Test-Server, kein Alerting',
      exFieldEnabled: 'Aktiv',
      exStructuredHint: 'Wird als negierter Filter in jede Condition injiziert — wirkt für alle Stream-Typen, auch Managed-Streams.',
      exRawHint: 'Wird als „AND NOT (…)" an die Queries von Kombi-/Custom-Streams gehängt, die der Bot pusht. Wirkt NICHT bei Managed-Streams — dafür strukturiert nutzen.',
      exRawScopeHint: 'Roh-Ausnahmen wirken immer kundenweit.',
      exWorkflowRequired: 'Bitte einen Workflow wählen.',
      exFieldRequired: 'Bitte ein Feld eingeben.',
      exRawRequired: 'Bitte einen Lucene-Ausdruck eingeben.',
      exclusionCreated: 'Ausnahme angelegt.',
      exclusionUpdated: 'Ausnahme aktualisiert.',
      exclusionSaveFailed: 'Speichern fehlgeschlagen.',
      exclusionDeleted: 'Ausnahme entfernt.',
      exclusionDeleteFailed: 'Löschen fehlgeschlagen.',
      exclusionConfirmDelete: 'Diese Ausnahme wirklich löschen?',

      // ── Detection Set tab ─────────────────────────────────────────────────
      workflowsTitle:      'Zugeordnete Workflows',
      streamsTitle:        'Zugeordnete Streams',
      addWorkflowsBtn:     'Workflows hinzufuegen',
      streamsAutoAdded:    'Workflow(s) hinzugefügt. Custom-/Kombi-Streams wurden automatisch in die Stream-Liste eingetragen, damit ihr Sync-Status sichtbar ist.',
      streamsWrappedInfo:  '{count} verwaltete(r) Stream(s) wurden als anpassbare Wrapper-Streams hinzugefügt (damit Incidents, Alarme und Ausnahmen darauf möglich sind).',
      addStreamsBtn:       'Streams hinzufuegen',
      removeWorkflowTip:   'Workflow entfernen',
      removeStreamTip:     'Stream entfernen',
      streamRemoveWorkflowBacked: 'Dieser Stream gehört zu einem Workflow im Detection-Set und kann nicht einzeln entfernt werden — entferne stattdessen den Workflow.',
      detectionLoadFailed: 'Detection-Set konnte nicht geladen werden.',
      workflowPickerTitle: 'Workflows hinzufuegen',
      workflowPickerHint: 'Es werden nur Workflows angezeigt, die mindestens einen Stream hinterlegt haben. Workflows ohne Streams können nicht mit Enginsight synchronisiert werden.',
      streamPickerTitle:   'Streams hinzufuegen',
      pickerSearchPlaceholder: 'Suchen…',
      pickerAddBtn:        'Ausgewaehlt hinzufuegen',
      pickerEmpty:         'Keine Eintraege gefunden.',
      pickerTabManaged:    'Verwaltete Kataloge',
      pickerTabCustom:     'Eigene Streams',
      pickerUncategorized: 'Ohne Kategorie',
      pickerCatCount:      '{count} Eintraege',
      pickerSelectCatalog: 'Waehle einen Katalog, um die enthaltenen Eintraege anzuzeigen',
      pickerSelectAllInGroup: 'Alle in dieser Rubrik auswaehlen',
      pickerSelectedCount: '{count} ausgewaehlt',
      pickerCapped:        'Es werden die ersten Ergebnisse gezeigt — ueber Tabs oder Suche eingrenzen.',
      streamWrapperBadge:  'Wrapper',
      addFailed:           'Hinzufuegen fehlgeschlagen.',
      removeFailed:        'Entfernen fehlgeschlagen.',
      colWorkflowName:     'Workflow',
      colWorkflowSeverity: 'Schweregrad',
      colWorkflowVis:      'Sichtbarkeit',
      colStreamName:       'Stream',
      colStreamCategory:   'Kategorie',
      colStreamType:       'Typ',
      colAddedAt:          'Hinzugefuegt',
      colSyncStatus:       'Sync',
      colEnginsightGuid:   'Enginsight ID',
      sync_pending:        'Ausstehend',
      sync_synced:         'Synchronisiert',
      sync_error:          'Fehler',
      sync_pending_delete: 'Wird entfernt…',
      streamManaged:       'Managed',
      streamCustom:        'Custom',
      streamManagedHint:   'Verwalteter Stream — auf jeder Enginsight-Instanz bereits vorhanden, kein Sync nötig.',
      streamManagedSyncHint: 'Verwaltete Streams sind nativ auf Enginsight vorhanden — kein Sync erforderlich.',

      // ── Stream-Incidents (Ereignisse) ─────────────────────────────────────
      colStreamIncidents:  'Ereignisse',
      incOn:               'An',
      incOff:              'Aus',
      streamIncidentsTip:  'Ereignisse konfigurieren',
      streamIncidentsWorkflowBacked: 'Ein Workflow im Detection-Set verarbeitet diesen Stream bereits — Ereignisse erzeugt der Workflow.',
      streamManagedIncidentsHint: 'Managed Streams können keine Ereignis-Einstellungen tragen. Lege einen Wrapper-Stream an, der ihn referenziert, und konfiguriere die Ereignisse auf dem Wrapper.',
      streamIncidentsTitle: 'Ereignisse — {name}',
      streamIncidentsHint: 'Steuert, ob und wie Enginsight aus diesem Stream direkt Ereignisse erzeugt. Getrennt von den Stream-Alarmen (Benachrichtigungen).',
      streamIncidentsSaved: 'Ereignis-Einstellungen gespeichert.',
      incEnabled:          'Ereignisse direkt auslösen',
      incCooldownValue:    'Ereignisverzögerung',
      incCooldownUnit:     'Einheit',
      incCooldownZeroHint: '0 = keine Verzögerung',
      incCooldownUnit_sec:  'Sekunden',
      incCooldownUnit_min:  'Minuten',
      incCooldownUnit_hour: 'Stunden',
      incCooldownUnit_day:  'Tage',
      incCooldownUnit_week: 'Wochen',
      incGroups:           'Gruppierung',
      incGroupsHint:       'Ereignisse nach Feld gruppieren, z. B. gen.hostname. Tippen und Enter zum Hinzufügen.',
      incSchedule:         'Ereigniszeitraum (Cron)',
      incScheduleAdd:      'Fenster hinzufügen',
      incScheduleHint:     'Cron-Ausdruck + IANA-Zeitzone, z. B. "* 8-18 * * 1-5" / Europe/Berlin.',
      incSeverity:         'Severity-Override',
      incSeverityDefault:  'Standard (mittel)',
      // Stream-Alarm (belongsTo: siemStream) — getrennt von den Ereignissen, eigener Dialog
      colStreamAlert:        'Alarm',
      streamAlertTitle:      'Stream-Alarm – {name}',
      streamAlertMode:       'Bindung',
      streamAlertModeStream: 'Dieser Stream',
      streamAlertModeTag:    'Alle Streams mit Tag',
      streamAlertNoTags:     'Dieser Stream hat keine Tags — nur ein per-Stream-Alarm ist möglich.',
      streamAlertTag:        'Tag',
      streamAlertTagScope:   'Gilt für ALLE Streams mit dem Tag »{tag}« — nicht nur für diesen.',
      streamAlertPickTag:    'Bitte einen Tag wählen.',
      streamAlertSaved:      'Stream-Alarm gespeichert.',
      streamAlertDeleted:    'Stream-Alarm gelöscht.',
      streamAlertPerStream:  'Per-Stream-Alarm aktiv',
      streamAlertViaTag:     'Aktiv über Tag: {tags}',
      streamAlertEnablesEvents: 'Mit dem Alarm werden auch die Ereignisse dieses Streams aktiviert (Voraussetzung — der Alarm feuert nur auf Ereignisse).',
      streamAlertTagEventsHint: 'Der Alarm feuert nur für getaggte Streams mit aktiven Ereignissen.',
      streamAlertWorkflowBacked: 'Ein Workflow im Detection-Set erzeugt für diesen Stream bereits den Alarm — kein separater Stream-Alarm nötig.',

      // ── Matches tab ───────────────────────────────────────────────────────
      matchesTitle:         'Hack-Post-Matches',
      matchFilterAll:       'Alle',
      matchFilterPending:   'Ausstehend',
      matchFilterConfirmed: 'Bestaetigt',
      matchFilterRejected:  'Abgelehnt',
      colMatchPost:         'Post',
      colMatchGroup:        'Bedrohungsakteur',
      colMatchScore:        'Konfidenz',
      colMatchSeverity:     'Schweregrad',
      colMatchStatus:       'Status',
      colMatchDate:         'Datum',
      colMatchActions:      'Aktionen',
      confirmMatchTip:      'Match bestaetigen',
      rejectMatchTip:       'Match ablehnen',
      confirmDialogTitle:   'Match bestaetigen',
      confirmDialogBody:    '"{title}" als Match fuer diesen Kunden bestaetigen?',
      confirmSeverityLabel: 'Schweregrad (optionale Korrektur)',
      confirmBtn:           'Bestaetigen',
      rejectBtn:            'Ablehnen',
      matchConfirmed:       'Match bestaetigt.',
      matchRejected:        'Match abgelehnt.',
      matchReviewFailed:    'Bewertung fehlgeschlagen.',
      matchesLoadFailed:    'Matches konnten nicht geladen werden.',
      matchesEmpty:         'Noch keine Match-Kandidaten vorhanden. Sobald ein Hack-Post diesem Kunden zugeordnet werden kann, erscheint er hier.',

      // ── Risk tab ─────────────────────────────────────────────────────────
      riskTitle:            'Risikobewertung',
      riskSeverityLabel:    'Aktueller Schweregrad',
      riskLookback:         'Zeitraum',
      riskLookback7:        'Letzte 7 Tage',
      riskLookback14:       'Letzte 14 Tage',
      riskLookback30:       'Letzte 30 Tage',
      riskLookback90:       'Letzte 90 Tage',
      riskDerivedMatches:   'Basiert auf bestaetigen Matches',
      riskDerivedContext:   'Basiert auf Sektor-/Landaktivitaet',
      riskDerivedManual:    'Manuell gesetzt',
      riskDerivedEscalated: 'Auto-eskaliert (Override überholt)',
      riskColScore:         'Score',
      riskTrendTitle:       'Risiko-Verlauf',
      riskTrendEmpty:       'Noch nicht genug Daten fuer einen Verlauf (mindestens 7 Tage).',
      riskLoadFailed:       'Risikobewertung konnte nicht geladen werden.',
      riskAutoLabel:        'Berechnet',
      riskManualBadge:      'Manuell',
      riskManualHint:       'Dieser Risk-Score wurde manuell gesetzt und überschreibt den berechneten Wert.',
      riskManualSetBy:      'Gesetzt von',
      riskOverrideSetBtn:   'Manuell setzen',
      riskOverrideEditBtn:  'Override bearbeiten',
      riskOverrideClearBtn: 'Auf automatisch zurücksetzen',
      riskOverrideClearHint: 'Manuellen Override entfernen; der berechnete Score gilt wieder.',
      riskOverrideDialogTitle: 'Manueller Risk-Override',
      riskOverrideIntro:    'Lege den Risiko-Schweregrad für diesen Kunden fest. Der manuelle Wert überschreibt den automatisch berechneten Score, bis du ihn zurücksetzt.',
      riskOverrideNoteLabel: 'Begründung / Notiz',
      riskOverrideNotePlaceholder: 'Warum wird das Risiko hoch- oder herabgestuft?',
      riskOverrideSaved:    'Manueller Risk-Override gespeichert.',
      riskOverrideSaveFailed: 'Risk-Override konnte nicht gespeichert werden.',
      riskOverrideCleared:  'Manueller Override entfernt — automatischer Score wieder aktiv.',
      riskOverrideClearFailed: 'Override konnte nicht entfernt werden.',
      riskOverrideClearConfirm: 'Risiko auf den automatisch berechneten Score zurücksetzen?',
      riskSupersededBadge:  'Override überholt',
      riskSupersededHint:   'Die Automatik ist über das Niveau gestiegen, das beim Setzen des Overrides galt — der höhere automatische Wert wird angezeigt.',
      riskSupersededNote:   'Dein manueller Wert ({manual}) wurde überholt: die automatische Bewertung ist auf {auto} eskaliert. Neu bestätigen, um eine neue Baseline zu setzen, oder auf automatisch zurücksetzen.',
      riskReviewBadge:      'Neu bewerten',
      riskReviewHint:       'Das Neubewertungs-Datum dieses Overrides ist erreicht — bitte neu einschätzen.',
      riskBaselineLabel:    'Baseline',
      riskReviewAtLabel:    'Neu bewerten am',
      riskReviewLabel:      'Erinnerung zur Neubewertung',
      riskReview7:          'In 7 Tagen',
      riskReview30:         'In 30 Tagen',
      riskReview90:         'In 90 Tagen',
      riskReviewNone:       'Keine Erinnerung',
      riskEscalationHint:   'Der Override friert das Risiko nicht ein: Steigt die Automatik über das aktuelle Niveau (neuer Match, steigende Branchen-/Länderaktivität), übernimmt wieder der höhere automatische Wert.',

      // ── Severity labels ───────────────────────────────────────────────────
      sevCritical: 'Kritisch',
      sevHigh:     'Hoch',
      sevMedium:   'Mittel',
      sevLow:      'Niedrig',
      sevNone:     'Kein Risiko',

      // ── Employee bucket labels ────────────────────────────────────────────
      bucket_1_49:      '1 - 49',
      bucket_50_249:    '50 - 249',
      bucket_250_999:   '250 - 999',
      bucket_1000_4999: '1.000 - 4.999',
      bucket_5000:      '5.000+',
    },
  },
};
